// extracted by mini-css-extract-plugin
export default {"container":"LandingPage_container__0SPwO","svgGraphic":"LandingPage_svgGraphic__qQQdp"};